<!-- 个人中心学习报告-->
<template>
  <div class="personalReport">
    <common-title titleName="学习报告" :bcColor="'#F9F9F9'" :zIndex="1000"> </common-title>
    <template v-if="!isEmpty">
      <section :class="['section', { inApp: $root.$data.isApp }]">
        <img
          v-if="pullNewList"
          @click="showPop"
          id="jinduPop"
          class="jindu"
          src="https://iqh-zt-pord-cdn.iqihang.com/%E7%BC%96%E7%BB%84%2029%402x.png"
        />
        <div v-if="popVisible" class="pop-toast">
          活动分享后，拉新进度可前往App【我的】-【我的活动】 页面查看
        </div>
        <section class="head-top">
          <div class="head-img">
            <img
              :src="userInfo.avatar || require('../../../assets/img/personalImg/defaultAvatar.png')"
            />
            <div>
              <span>亲爱的 {{ userInfo.nickName || userInfo.userName }}</span>
              <p>{{ quotesSentence }}</p>
            </div>
          </div>
          <div class="head-time">
            <div>你第一天加入启航是{{ studyInfo.registerTime }}</div>
            <div>
              陪伴启航已经<span>{{ studyInfo.registerDay || 0 }}</span
              >天了
            </div>
          </div>
        </section>

        <StudyProgress :studyInfo="studyInfo" />
        <StudyColumn v-if="weekTimeList" :weekTimeList="weekTimeList" />
        <SubjectColumn v-if="studyInfo.isShow && subjectList" :subjectList="subjectList" />
      </section>
      <div v-if="pullNewList" class="gift-list">
        <span @click="showGiftList">分享后有机会获得这些奖品，戳这里看看 >></span>
      </div>
      <div class="share-btn-Box">
        <button class="share-btn" @click="toShare">分享</button>
      </div>
      <van-popup
        :style="{ maxHeight: '705px' }"
        round
        :closeable="true"
        v-model="showGiftVisible"
        position="bottom"
      >
        <GiftList :giftListData="giftListData" />
      </van-popup>
      <ShareReport
        v-if="showShare"
        :studyInfo="studyInfo"
        :quotesSentence="quotesSentence"
        :pullNewList="pullNewList"
      />
    </template>
    <EmptyData v-else :emptyName="'noReport'" />
    <CommonLoading v-if="loading" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import EmptyData from '@/components/emptyData/emptyData.vue';
import { replaceHyphens } from '@/utils/tools';
import CommonLoading from '@/components/commonComponents/CommonLoading.vue';
import {
  reqPersonalBasisInfo,
  reqPersonalServiceInfo,
  reqPersonalWeekTime,
  reqPersonalSubjectInfo,
  reqPersonalBindPullNew,
} from '@/api/personal/personalReport';
import { getPullNewInfoApi } from '@/api/pullNew';
import ShareReport from './shareReport.vue';
import StudyProgress from './studyProgress.vue';
import StudyColumn from './studyColumn.vue';
import SubjectColumn from './subjectColumn.vue';
import GiftList from './components/giftList';

export default {
  components: {
    ShareReport,
    StudyProgress,
    EmptyData,
    StudyColumn,
    SubjectColumn,
    CommonLoading,
    GiftList,
  },
  data() {
    return {
      showShare: false,
      studyInfo: {},
      isEmpty: false,
      weekTimeList: null, // 上周学习时长
      loading: true,
      subjectList: null, // 各学科学习时长
      pullNewList: null, // 是否有拉新
      quotesSentence: '放弃很容易，但坚持一定很酷！',
      popVisible: false,
      showGiftVisible: false,
      giftListData: [],
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  methods: {
    toShare() {
      if (this.loading) return;
      this.showShare = true;
    },
    getQuotes() {
      const quotesList = [
        '放弃很容易，但坚持一定很酷！',
        '要想走出平凡，就要先走入孤独。',
        '星光不负赶路人，加油，考研人！',
        '谋人事，成天命，所有的努力不会被辜负。',
        '如果世上真有奇迹，那一定是努力的另一个名字。',
        '骏马是跑出来的，强兵是打出来的。',
        '勤奋是你生命的密码，能译出你一部壮丽的史诗。',
        '选择了考研就选择了孤独。',
        '今天能够做的事，切莫拖延到明天。',
        '付出总有回报，梦想定能成真。',
      ];
      const randomItem = quotesList[Math.floor(Math.random() * quotesList.length)];
      this.quotesSentence = randomItem;
    },
    async getStudyBasisInfo() {
      // 查询学习报告基础信息;
      const p1 = reqPersonalBasisInfo();
      // 查询学习报告服务信息
      const p2 = reqPersonalServiceInfo();
      // 查询学习报告各学科学习时长信息
      const p3 = reqPersonalSubjectInfo();
      // 查询学习报告周学习时长信息
      const p4 = reqPersonalWeekTime();
      // 查询是否绑定拉新
      const p5 = reqPersonalBindPullNew();

      Promise.all([p1, p2, p3, p4, p5]).then(async (result) => {
        const res = result[0];
        const res1 = result[1];
        const res2 = result[2];
        const res3 = result[3];
        const res4 = result[4];
        this.loading = false;
        if (!res.data && !res1.data && !res2.data && !res3.data && !res4.data) {
          this.isEmpty = true;
          return;
        }
        this.studyInfo = {
          ...res?.data,
          ...res1?.data,
        };
        // 各学科学习时长
        const subjectList = res2?.data?.length > 0 ? res2?.data : null;
        // 上周学习时长
        const weekTimeList = res3?.data?.length > 0 ? res3?.data : null;
        // 是否绑定拉新
        this.pullNewList = res4?.data;
        if (res4?.data) {
          const { data } = await getPullNewInfoApi(res4?.data?.activityId, 0);
          this.giftListData = data?.pullNewActivityPrizeDataList;
          this.handlePopToast();
        }
        // 学习时间都为0 不展示
        if (weekTimeList?.every((item) => item.dayLearnDuration === 0)) {
          this.weekTimeList = null;
        } else {
          const mapData = weekTimeList?.map((item) => ({
            name: replaceHyphens(item.name).slice(5),
            dayLearnDuration: Math.ceil(item.dayLearnDuration / 60),
          }));
          this.weekTimeList = mapData;
        }
        // 各学科-学习时间都为0不展示， studyInfo中isShow为false隐藏该模块
        if (subjectList?.every((item) => item.dayLearnDuration === 0)) {
          this.subjectList = null;
        } else {
          // eslint-disable-next-line no-unused-expressions
          const mapData = subjectList?.map((item) => ({
            name: item.name,
            dayLearnDuration: this.ceilNum((item.dayLearnDuration / 3600).toFixed(2)),
          }));
          this.subjectList = mapData;
        }
      });
    },
    // 任意位正小数，向上进位
    ceilNum(d, prex = 1) {
      // if (parseInt(d) == d) return d;
      if (parseInt(d) == d) {
        return Number(d) === 0 ? 0 : d;
      }

      let len = 1;
      let i = 0;
      while (parseInt(d) != d) {
        d *= 10;
        len *= 10;
        i++;
      }
      const last = Math.abs(i <= prex ? 0 : d % Math.pow(10, i - prex));
      let d1 = d - last;
      if (last > 0) {
        d1 += Math.pow(10, i - prex);
      }
      d1 /= len;
      return d1;
    },
    change() {
      const docEl = document.documentElement;
      if (docEl.clientWidth > 470) {
        setTimeout(() => {
          docEl.style.fontSize = '40px';
        }, 300);
      }
    },
    showPop() {
      this.popVisible = true;
    },
    handlePopToast() {
      document.addEventListener('mouseup', (e) => {
        const pop = document.getElementById('jinduPop');
        if (!pop.contains(e.target)) {
          this.popVisible = false;
        }
      });
    },
    showGiftList() {
      this.showGiftVisible = true;
    },
  },
  created() {
    this.change();
    window.onresize = () => {
      this.change();
    };
  },
  mounted() {
    this.getStudyBasisInfo();
    this.getQuotes();
  },
};
</script>
<style lang="scss" scoped>
.personalReport {
  .section {
    position: relative;
    padding: 100px 0 110px 0;
    .jindu {
      position: absolute;
      top: 34px;
      right: 36px;
      width: 29px;
      height: 29px;
    }
    .pop-toast {
      position: absolute;
      top: 68px;
      left: 36px;
      box-sizing: border-box;
      width: 678px;
      height: 107px;
      padding: 16px 18px;
      color: #fff;
      font-weight: 400;
      font-size: 25px;
      line-height: 40px;
      background-image: url('https://iqh-zt-pord-cdn.iqihang.com/%E7%9F%A9%E5%BD%A2%402x.png');
      background-size: 100%;
    }
    &.inApp {
      padding-top: 0;
    }
  }

  .head-top {
    width: 750px;
    height: 438px;
    margin: 0 auto;
    padding: 58px 30px 0 36px;
    background-color: #ff6b00;
    background-image: url('../../../assets/img/learningGuidePage/report-head.png');
    background-repeat: no-repeat;
    background-size: 100%;
    .head-img {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      > img {
        width: 109px;
        height: 109px;
        margin-right: 22px;
        border: 5px solid #fff;
        border-radius: 50%;
      }
      > div {
        span {
          display: inline-block;
          width: 350px;
          overflow: hidden;
          color: #fff;
          font-weight: 500;
          font-size: 29px;
          line-height: 40px;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        p {
          color: #fff;
          font-weight: 500;
          font-size: 25px;
          line-height: 36px;
        }
      }
    }
    .head-time {
      padding: 36px 0 33px 0;
      > div {
        margin-bottom: 14px;
        color: #fff;
        font-weight: 400;
        font-size: 25px;
        line-height: 36px;
        span {
          margin: 0 4px;
          padding: 0 8px;
          color: #ff7f41;
          font-weight: 600;
          font-size: 25px;
          background: #fff;
          border-radius: 18px;
        }
      }
    }
  }
  .study-progress {
    position: relative;
    top: -110px;
    z-index: 1;
  }
  .study-week {
    position: relative;
    top: -130px;
    z-index: 1;
  }
  .columnBoxPer {
    position: relative;
    top: -88px;
  }
  .subjectColumnBox {
    position: relative;
    top: -68px;
  }
  .share-btn-Box {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    background: #fff;
    .share-btn {
      width: 678px;
      margin: 0 auto 36px auto;
      color: #fff;
      font-weight: 500;
      font-size: 29px;
      line-height: 80px;
      background: #ff7f41;
      border-radius: 45px;
    }
  }
  .gift-list {
    position: fixed;
    bottom: 138px;
    left: 0;
    width: 100%;
    height: 54px;
    line-height: 34px;
    text-align: center;
    span {
      display: inline-block;
      padding: 9px 47px;
      color: #ff7f41;
      font-weight: 500;
      font-size: 25px;
      background: rgba(255, 127, 65, 0.1);
      border-radius: 7px;
    }
  }
  .emptyIndent {
    padding-top: 200px;
  }
}
</style>
